import z from "zod";

export const TEditUser = z.object({
  id: z.string().optional(),
  email: z.email().trim(),
  first_name: z.string().trim().min(2).max(100),
  last_name: z.string().trim().min(2).max(100),
  phone_number: z.string().trim().min(10).max(15),
  picture: z.string().optional(),
});

export type TEditUserSchema = z.infer<typeof TEditUser>;
